import '@/common';
import { createSliderWidget } from '@/widgets/SliderWidget';

const sliderEl = document.querySelector('#slider-widget')
if(sliderEl) {
    createSliderWidget(sliderEl);
}
